import { cn } from '@/lib/utils';
import { hasVisibleFilterItems } from '../index-section-utils';
import {
  IndexSectionBackgroundShell,
  IndexSectionCollectionHeading,
  IndexSectionContainer,
  IndexSectionFilterTabs,
  type IndexSectionViewProps,
  shouldShowCollection,
  shouldShowPinnedCollection,
} from './shared';

export function GridIndexSectionView({
  layoutProps,
  sectionBackgroundColor,
  filters,
  pinnedCollection,
  collection,
}: IndexSectionViewProps) {
  const canShowFilters = filters.show && hasVisibleFilterItems(filters.items);
  const collectionHeading = canShowFilters ? undefined : collection.heading;

  return (
    <IndexSectionBackgroundShell sectionBackgroundColor={sectionBackgroundColor}>
      {shouldShowPinnedCollection(pinnedCollection) ? (
        pinnedCollection?.fullWidth ? (
          pinnedCollection.body
        ) : (
          <IndexSectionContainer layoutProps={layoutProps}>
            {pinnedCollection?.body}
          </IndexSectionContainer>
        )
      ) : null}

      <IndexSectionContainer layoutProps={layoutProps}>
        <div className={cn('space-y-8', 'w-full')}>
          <IndexSectionFilterTabs
            showFilters={canShowFilters}
            filterItems={filters.items}
            filterKey={filters.key}
            filterLabel={filters.label}
            filterLimit={filters.limit}
            filterBlock={filters.block}
          />

          {shouldShowCollection(collection) && (
            <div className="space-y-6">
              <IndexSectionCollectionHeading heading={collectionHeading} />
              {collection.body}
              {collection.pagination}
            </div>
          )}
        </div>
      </IndexSectionContainer>
    </IndexSectionBackgroundShell>
  );
}
